module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "SpSenderForm"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼をする")]), _vm._v(" "), (_vm.check_tankiuser()) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.check_tankiuser()) ? _c('div', [_c('section', {
    staticClass: "section",
    attrs: {
      "id": "first-section"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("振替を希望する授業を以下のリストから選択してください")]), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.selectedReservation && !_vm.isOther) ? _c('div', {
    key: "warning-first-unselected"
  }, [_c('notificationBox', {
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "振替を希望する授業を選択してください"
    }
  })], 1) : (_vm.isCompletenessChecking && !_vm.isFirstCompleted) ? _c('notificationBox', {
    key: "warning-first-unspecified",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "授業の情報を全て指定してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isFirstCompleted) ? _c('notificationBox', {
    key: "ok-first",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("授業数：" + _vm._s(_vm.reservations.length) + "件")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "reservation-list"
    }
  }, _vm._l((_vm.reservations), function(reservation, index) {
    return _c('li', {
      key: 'reservation' + index,
      staticClass: "list-item list-item-reservation"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedReservation),
        expression: "selectedReservation"
      }],
      attrs: {
        "id": 'list-item-reservation-radio' + index,
        "type": "radio",
        "disabled": _vm.isOther || reservation.expireCheck
      },
      domProps: {
        "value": reservation,
        "checked": _vm._q(_vm.selectedReservation, reservation)
      },
      on: {
        "change": [function($event) {
          _vm.selectedReservation = reservation
        }, function($event) {
          _vm.reservationChanged()
        }]
      }
    }), _vm._v(" "), (!reservation.expireCheck) ? _c('label', {
      attrs: {
        "for": 'list-item-reservation-radio' + index
      }
    }, [_vm._v(_vm._s(reservation.text))]) : _c('label', {
      staticStyle: {
        "color": "#989898"
      },
      attrs: {
        "for": 'list-item-reservation-radio' + index
      },
      on: {
        "click": function($event) {
          _vm.alert('授業振替ではなく授業キャンセルとなるので、別途究進塾にご連絡（電話orメール）ください')
        }
      }
    }, [_vm._v(_vm._s(reservation.text) + "  期限切れです")])])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOther),
      expression: "isOther"
    }],
    attrs: {
      "id": "otherCheck",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOther) ? _vm._i(_vm.isOther, null) > -1 : (_vm.isOther)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isOther,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOther = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOther = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOther = $$c
        }
      }, function($event) {
        _vm.reservationChanged()
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "otherCheck"
    }
  }, [_vm._v("上記以外の授業")]), _vm._v(" "), (_vm.isOther) ? _c('div', {
    key: "other-reservation",
    attrs: {
      "id": "other-reservation-box"
    }
  }, [(_vm.$store.state.userInfo.user_type === 'teacher') ? _c('div', {
    key: "select-student"
  }, [_c('label', [_vm._v("生徒のお名前：")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggestions": _vm.studentList
    },
    model: {
      value: (_vm.otherReservation.receiver),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "receiver", $$v)
      },
      expression: "otherReservation.receiver"
    }
  })], 1) : (_vm.$store.state.userInfo.user_type === 'student') ? _c('div', {
    key: "select-teacher"
  }, [_c('label', [_vm._v("先生のお名前：")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggestions": _vm.teacherList
    },
    model: {
      value: (_vm.otherReservation.receiver),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "receiver", $$v)
      },
      expression: "otherReservation.receiver"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "placeholder": "日付を選択",
      "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(_vm.otherReservation.date)) + ')',
      "value-format": "yyyy-MM-dd",
      "picker-options": {
        disabledDate: _vm.disabledDate
      }
    },
    model: {
      value: (_vm.otherReservation.date),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "date", $$v)
      },
      expression: "otherReservation.date"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "開始時刻を選択",
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        maxTime: _vm.otherReservation.endTime,
      }
    },
    model: {
      value: (_vm.otherReservation.startTime),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "startTime", $$v)
      },
      expression: "otherReservation.startTime"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "終了時刻を選択",
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        minTime: _vm.otherReservation.startTime
      }
    },
    model: {
      value: (_vm.otherReservation.endTime),
      callback: function($$v) {
        _vm.$set(_vm.otherReservation, "endTime", $$v)
      },
      expression: "otherReservation.endTime"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "second-section"
    }
  }, [_vm._m(3), _vm._v(" "), (!_vm.isFirstCompleted) ? _c('notificationBox', {
    key: "warning-second-uncompleted-first",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "候補日時を指定する前に振替を希望する授業を選択してください"
    }
  }) : (_vm.isCompletenessChecking && !_vm.isSecondCompleted) ? _c('notificationBox', {
    key: "warning-second-unspecified",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "全ての候補日時の日付、開始時刻，終了時刻を指定してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isSecondCompleted) ? _c('notificationBox', {
    key: "ok-second",
    staticClass: "notificationBox",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFirstCompleted) ? _c('div', {
    key: "candidate-list"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.candidateDatetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.candidateDatetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
      staticStyle: {
        "width": "190px"
      },
      attrs: {
        "placeholder": "日付を選択",
        "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(cand.date)) + ')',
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: _vm.disabledDate
        }
      },
      model: {
        value: (cand.date),
        callback: function($$v) {
          _vm.$set(cand, "date", $$v)
        },
        expression: "cand.date"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-slot-mode' + index,
        "type": "radio",
        "value": "slot",
        "readonly": "readonly"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "slot")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "slot")
        }, function($event) {
          cand.startTime = null;
          cand.endTime = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-slot-mode' + index
      }
    }, [_vm._v("1コマ分を指定")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-range-mode' + index,
        "type": "radio",
        "value": "range"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "range")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "range")
        }, function($event) {
          cand.startTime = null;
          cand.endTime = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-range-mode' + index
      }
    }, [_vm._v("範囲で指定")])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "開始時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          maxTime: _vm.getMaxStartTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateStartTimeChanged(cand)
        }
      },
      model: {
        value: (cand.startTime),
        callback: function($$v) {
          _vm.$set(cand, "startTime", $$v)
        },
        expression: "cand.startTime"
      }
    }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "終了時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: _vm.getMinEndTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateEndTimeChanged(cand)
        }
      },
      model: {
        value: (cand.endTime),
        callback: function($$v) {
          _vm.$set(cand, "endTime", $$v)
        },
        expression: "cand.endTime"
      }
    }), _vm._v(" "), (cand.mode === 'slot') ? _c('label', {
      key: "slot-mode"
    }, [_vm._v("\n                  の1コマ\n                ")]) : (cand.mode === 'range') ? _c('label', {
      key: "range-mode"
    }, [_vm._v("\n                  の中で" + _vm._s(_vm.reservationDuration) + "分間\n                ")]) : _vm._e()], 1)])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  }, [_vm._v("\n          ＋ 候補日時を追加する\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "third-section"
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isThirdCompleted) ? _c('notificationBox', {
    key: "warning-third",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "理由は必須項目です"
    }
  }) : (_vm.isCompletenessChecking && _vm.isThirdCompleted) ? _c('notificationBox', {
    key: "ok-third",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-area"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "理由を入力してください",
      "rows": "3"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', {
    key: "fourth-section",
    attrs: {
      "id": "fourth-section"
    }
  }, [_vm._m(5), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isFourthCompleted) ? _c('notificationBox', {
    key: "warning-fourth",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "warning",
      "text": "授業の種類，配布物の有無を入力してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isFourthCompleted) ? _c('notificationBox', {
    key: "ok-fourth",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_vm._v("\n      入力内容を確認する\n    ")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('p', [_vm._v("恐れ入りますが、短期コースを受講されている方は振替機能をご利用いただけません。")]), _vm._v(" "), _c('p', [_vm._v("振替をご希望の方は究進塾事務局")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@kyushinjuku.com"
    }
  }, [_vm._v("(info@kyushinjuku.com)")]), _vm._v(" "), _c('p', [_vm._v("へ、授業前日22時までにご連絡ください。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 1")]), _vm._v(" : 授業の選択")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('p', [_vm._v("振替依頼は、必ず授業前日22:00までに完了してください。")]), _vm._v(" "), _c('p', [_vm._v("それ以降は振替依頼をすることが出来ません。")]), _vm._v(" "), _c('p', [_vm._v("授業前日22:00を過ぎた場合は振替ではなくキャンセルとなりますので、")]), _vm._v(" "), _c('p', [_vm._v("お電話またはメールにて事務局までご連絡ください。")]), _vm._v(" "), _c('p', [_vm._v("TEL:03-5927-1660 (日曜/年末年始を除く13:00-21:00)")]), _vm._v(" "), _c('p', [_vm._v("MAIL : info@kyushinjuku.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 2")]), _vm._v(" :   振替候補日時を指定してください")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 3")]), _vm._v(" :   振替を希望する理由を入力してください（必須）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "section-description"
  }, [_c('span', {
    staticClass: "step-section"
  }, [_vm._v("STEP 4")]), _vm._v(" :   振替"), _c('b', [_vm._v("後")]), _vm._v("の授業の情報を指定してください")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18474b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/ReschedulingPage/SpSenderForm.vue
// module id = 672
// module chunks = 0